/*
 * Product titles wrap to a different number of lines depending on their length.
 * That pushes the price, savings, discount code and delivery text below them out
 * of alignment between cards in the same row. This measures the tallest title in
 * each row of product cards and gives every title in that row the same height, so
 * everything below lines up regardless of how long any single title is.
 */
(function () {
  var TITLE_SELECTOR = '.product-card__title';
  var ROW_TOLERANCE = 4;
  var scheduled = false;
  var observedContainers = new WeakSet();
  var resizeObserver = null;

  function findRowContainer(title) {
    var card = title.closest('.product-card');
    var node = card && card.parentElement;
    while (node && node !== document.body) {
      if (node.querySelectorAll(TITLE_SELECTOR).length > 1) return node;
      node = node.parentElement;
    }
    return null;
  }

  function equalizeTitles() {
    var titles = Array.prototype.slice.call(document.querySelectorAll(TITLE_SELECTOR));
    if (!titles.length) return;

    titles.forEach(function (title) {
      title.style.removeProperty('min-height');
    });

    var containers = new Map();
    titles.forEach(function (title) {
      if (title.offsetParent === null) return;
      var container = findRowContainer(title);
      if (!container) return;
      if (!containers.has(container)) containers.set(container, []);
      containers.get(container).push(title);

      if (resizeObserver && !observedContainers.has(container)) {
        observedContainers.add(container);
        resizeObserver.observe(container);
      }
    });

    containers.forEach(function (containerTitles) {
      var rows = [];
      containerTitles.forEach(function (title) {
        var top = title.getBoundingClientRect().top;
        var row = rows.filter(function (r) {
          return Math.abs(r.top - top) < ROW_TOLERANCE;
        })[0];
        if (!row) {
          row = { top: top, titles: [] };
          rows.push(row);
        }
        row.titles.push(title);
      });

      rows.forEach(function (row) {
        if (row.titles.length < 2) return;
        var maxHeight = Math.max.apply(
          null,
          row.titles.map(function (t) {
            return t.getBoundingClientRect().height;
          })
        );
        row.titles.forEach(function (t) {
          t.style.minHeight = maxHeight + 'px';
        });
      });
    });
  }

  function scheduleEqualize() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      equalizeTitles();
    });
  }

  if ('ResizeObserver' in window) {
    resizeObserver = new ResizeObserver(scheduleEqualize);
  }

  var resizeTimeout;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(scheduleEqualize, 150);
  });

  document.addEventListener('collection:rerendered', scheduleEqualize);
  window.addEventListener('load', scheduleEqualize);

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(scheduleEqualize);
  }

  if ('MutationObserver' in window) {
    var mutationObserver = new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (m) {
        return m.addedNodes.length || m.removedNodes.length;
      });
      if (relevant) scheduleEqualize();
    });
    mutationObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleEqualize);
  } else {
    scheduleEqualize();
  }
})();
